import get from 'lodash/get';
import { FundManagerExtended } from '../models/entity';

export function getExtendedValue(
    property: string,
    extended: FundManagerExtended
): string {
    return get(extended, `${property}.value`, get(extended, `${property}`, ''));
}



// WEBPACK FOOTER //
// ./src/utils/getExtendedValue.ts